import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "about" }

import {reactive} from "vue";
import {loginByPassword} from "@/apis/auth";
import {handleLoginSuccess} from "@/utils/auth";
import settings from "@/config/settings.config";
import {getQueryString} from "@/utils/tools";


export default /*#__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const loginParam = reactive({
  phone: '18510249246',
  password: '89832488',
  loginType: 'PHONE',
  appName: settings.appName
})

const handleLoginSubmit = () => {
  loginByPassword(loginParam).then((res) => {
    if (res.code === 200) {
      handleLoginSuccess(res.data)
      let path = getQueryString('path');
      window.location.href = path || '/'
    }else{
      alert(res.msg);
    }
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "text",
      name: "phone",
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((loginParam.phone) = $event))
    }, null, 512), [
      [_vModelText, loginParam.phone]
    ]),
    _withDirectives(_createElementVNode("input", {
      type: "password",
      name: "password",
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loginParam.password) = $event))
    }, null, 512), [
      [_vModelText, loginParam.password]
    ]),
    _createElementVNode("button", { onClick: handleLoginSubmit }, "登录")
  ]))
}
}

})